import { render, staticRenderFns } from "./SalaryCalculatorBenefits.vue?vue&type=template&id=7ea38c2f&"
import script from "./SalaryCalculatorBenefits.vue?vue&type=script&lang=js&"
export * from "./SalaryCalculatorBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports